module.exports = __webpack_public_path__ + "img/Toolmanagementsystem_einfarbig_RGB.b0f18ccf.svg";